// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./react-app-env.d.ts" />

import React from "react";
// @ts-ignore
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import store from "./store";

import "./Setup";

import App from "./App";
import "./stylesheet/main.scss";
import * as Bootstrap from "./lib/Bootstrap";

import "./Api";
import WindowInterface from "./lib/util/WindowInterface";

window.__util = WindowInterface;

Bootstrap.pageInit();
window.addEventListener("load", Bootstrap.pageLoad, true);

createRoot(document.getElementById("root")).render(
	<Provider store={store}>
		<App />
	</Provider>,
);
